<template>
  <td>
    <span
      class="lamp"
      :class="value ? 'green' : 'orange'"
    >{{value ? '확인' : '미확인'}}</span>
  </td>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
};
</script>

<style>
</style>